export const QMS_REMOVE_EMAIL_LINK_BLOCK_REASON =
  "Document links are not allowed in the remove-access email. The recipient no longer has library access, so an Open document link would not work.";

export const QMS_ASSIGN_USE_OPEN_LINK_ONLY_REASON =
  "Use {{DocumentOpenLink}} only for the document button. Do not use {{DocumentUrl}} or paste a manual document link.";

export const QMS_EMAIL_IMAGE_BLOCK_REASON =
  "Images cannot be pasted into email templates. Use text and merge tags only.";

const FORBIDDEN_REMOVE_LINK_PATTERNS = [
  /\{\{\s*DocumentUrl\s*\}\}/i,
  /\{\{\s*DocumentOpenLink\s*\}\}/i,
  /qms\/library(?:\?|$)/i,
  /Home\/Index[^\s"'<>]*DMS_DOCUMENTLIBRARY/i,
  /DMS_DOCUMENTLIBRARY/i,
  /<a\b[^>]*href\s*=\s*["'][^"']*(?:qms\/library|Home\/Index|DMS_DOCUMENTLIBRARY)[^"']*["']/i,
  /<a\b[^>]*>\s*Open document\s*<\/a>/i,
  /Open document["']\s*rel\s*=/i,
];

const MANUAL_DOCUMENT_LINK_PATTERNS = [
  /\{\{\s*DocumentUrl\s*\}\}/i,
  /qms\/library(?:\?|$)/i,
  /Home\/Index[^\s"'<>]*DMS_DOCUMENTLIBRARY/i,
  /DMS_DOCUMENTLIBRARY/i,
  /<a\b[^>]*href\s*=\s*["'][^"']*(?:qms\/library|Home\/Index|DMS_DOCUMENTLIBRARY)[^"']*["']/i,
  /<a\b[^>]*>\s*Open document\s*<\/a>/i,
];

function containsEmbeddedImageContent(value) {
  const source = String(value || "");
  if (!source.trim()) return false;
  return /<img\b/i.test(source) || /data:image\//i.test(source);
}

function matchesAnyPattern(value, patterns) {
  const source = String(value || "");
  if (!source.trim()) return false;
  const plain = source.replace(/<[^>]+>/g, " ");
  return patterns.some((pattern) => pattern.test(source) || pattern.test(plain));
}

export function containsForbiddenRemoveDocumentLinkContent(value) {
  return matchesAnyPattern(value, FORBIDDEN_REMOVE_LINK_PATTERNS);
}

export function containsForbiddenAssignDocumentLinkContent(value) {
  return matchesAnyPattern(value, MANUAL_DOCUMENT_LINK_PATTERNS);
}

function validateNoImages(value) {
  if (containsEmbeddedImageContent(value)) {
    return { allowed: false, message: QMS_EMAIL_IMAGE_BLOCK_REASON };
  }
  return { allowed: true };
}

export function validateRemoveEmailSubject(subject) {
  const imageCheck = validateNoImages(subject);
  if (!imageCheck.allowed) return imageCheck;
  if (containsForbiddenRemoveDocumentLinkContent(subject)) {
    return { allowed: false, message: QMS_REMOVE_EMAIL_LINK_BLOCK_REASON };
  }
  return { allowed: true };
}

export function validateRemoveEmailBody(html) {
  const imageCheck = validateNoImages(html);
  if (!imageCheck.allowed) return imageCheck;
  if (containsForbiddenRemoveDocumentLinkContent(html)) {
    return { allowed: false, message: QMS_REMOVE_EMAIL_LINK_BLOCK_REASON };
  }
  return { allowed: true };
}

export function validateAssignEmailSubject(subject) {
  const imageCheck = validateNoImages(subject);
  if (!imageCheck.allowed) return imageCheck;
  if (containsForbiddenAssignDocumentLinkContent(subject)) {
    return { allowed: false, message: QMS_ASSIGN_USE_OPEN_LINK_ONLY_REASON };
  }
  return { allowed: true };
}

export function validateAssignEmailBody(html) {
  const imageCheck = validateNoImages(html);
  if (!imageCheck.allowed) return imageCheck;
  if (containsForbiddenAssignDocumentLinkContent(html)) {
    return { allowed: false, message: QMS_ASSIGN_USE_OPEN_LINK_ONLY_REASON };
  }
  return { allowed: true };
}

export const QMS_TRANSFER_USE_MY_VAULT_LINK_ONLY_REASON =
  "Use {{MyVaultOpenLink}} only for the My Vault button. Do not use {{MyVaultUrl}} or paste a manual My Vault link.";

const MANUAL_MY_VAULT_LINK_PATTERNS = [
  /\{\{\s*MyVaultUrl\s*\}\}/i,
  /qms\/my-vault(?:\?|$)/i,
  /<a\b[^>]*href\s*=\s*["'][^"']*qms\/my-vault[^"']*["']/i,
  /<a\b[^>]*>\s*Open My Vault\s*<\/a>/i,
];

export function containsForbiddenTransferMyVaultLinkContent(value) {
  return matchesAnyPattern(value, MANUAL_MY_VAULT_LINK_PATTERNS);
}

export function validateTransferOwnershipEmailSubject(subject) {
  const imageCheck = validateNoImages(subject);
  if (!imageCheck.allowed) return imageCheck;
  if (containsForbiddenTransferMyVaultLinkContent(subject)) {
    return { allowed: false, message: QMS_TRANSFER_USE_MY_VAULT_LINK_ONLY_REASON };
  }
  return { allowed: true };
}

export function validateTransferOwnershipEmailBody(html) {
  const imageCheck = validateNoImages(html);
  if (!imageCheck.allowed) return imageCheck;
  if (containsForbiddenTransferMyVaultLinkContent(html)) {
    return { allowed: false, message: QMS_TRANSFER_USE_MY_VAULT_LINK_ONLY_REASON };
  }
  return { allowed: true };
}
